var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c(
      "div",
      { staticClass: "q-display-1 q-mb-md text-secondary" },
      [
        _c("q-icon", {
          staticClass: "q-mb-sm",
          attrs: { name: "fas fa-boxes" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("categories_modules")) + "\n    ")
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-sm" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-field",
            { attrs: { count: 256 } },
            [
              _c("q-input", {
                attrs: {
                  "float-label": _vm.$t("title"),
                  error: _vm.$v.title.$error
                },
                on: { input: _vm.$v.title.$touch },
                model: {
                  value: _vm.title,
                  callback: function($$v) {
                    _vm.title = $$v
                  },
                  expression: "title"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 q-mt-sm" },
        [
          _c("q-checkbox", {
            attrs: { val: true, label: _vm.$t("select_all_areas") },
            on: {
              input: function($event) {
                return _vm.checkAllAreas()
              }
            },
            model: {
              value: _vm.all_areas,
              callback: function($$v) {
                _vm.all_areas = $$v
              },
              expression: "all_areas"
            }
          }),
          _c("q-select", {
            attrs: {
              options: _vm.areas,
              "float-label": _vm.$t("areas"),
              error: _vm.$v.area.$error,
              multiple: "",
              chips: "",
              clearable: ""
            },
            on: { input: _vm.$v.area.$touch, clear: _vm.deselectAreas },
            model: {
              value: _vm.area,
              callback: function($$v) {
                _vm.area = $$v
              },
              expression: "area"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("p", { staticClass: "caption" }, [
            _vm._v(_vm._s(_vm.$t("status")))
          ]),
          _c("q-btn-toggle", {
            attrs: {
              "toggle-color": _vm.getColorStatus,
              options: _vm.status_list
            },
            model: {
              value: _vm.status,
              callback: function($$v) {
                _vm.status = $$v
              },
              expression: "status"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "fas fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "product_categories" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("save"),
              icon: "far fa-save"
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }